import React from 'react';
import { useI18n, availableLanguages } from '../context/I18nContext';
import { Globe } from 'lucide-react';

export default function LanguageSelector({ variant = 'dropdown' }) {
  const { language, changeLanguage, t } = useI18n();

  if (variant === 'buttons') {
    return (
      <div className="flex flex-wrap gap-2">
        {availableLanguages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`flex items-center px-3 py-2 rounded-lg border transition ${
              language === lang.code
                ? 'bg-blue-600 text-white border-blue-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            <span className="text-lg mr-2">{lang.flag}</span>
            <span className="text-sm">{lang.name}</span>
          </button>
        ))}
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="flex items-center space-x-1">
        {availableLanguages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`p-2 rounded-lg text-lg transition ${
              language === lang.code
                ? 'bg-blue-100 ring-2 ring-blue-500'
                : 'hover:bg-gray-100'
            }`}
            title={lang.name}
          >
            {lang.flag}
          </button>
        ))}
      </div>
    );
  }

  // Default: dropdown
  return (
    <div className="relative">
      <div className="flex items-center">
        <Globe className="w-4 h-4 text-gray-500 mr-2" />
        <select
          value={language}
          onChange={(e) => changeLanguage(e.target.value)}
          className="appearance-none bg-white border border-gray-300 rounded-lg px-3 py-2 pr-8 focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
        >
          {availableLanguages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.flag} {lang.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
